import { FormControlLabel, Checkbox, Box } from "@mui/material";
import type { WeekDay } from "Types/WeekDay";
import { useWeekDayOptions } from "Hooks/Options/useWeekDayOptions";

type Props = {
  selectedDays: Set<WeekDay>;
  onToggle: (day: WeekDay) => void;
};

export const DaySelector = ({ selectedDays, onToggle }: Props) => {
  const weekDayOptions = useWeekDayOptions();

  return (
    <Box display="flex" flexWrap="wrap" mb={2} columnGap={2} rowGap={0}>
      {weekDayOptions.map(({ id, name }) => (
        <FormControlLabel
          key={id}
          control={
            <Checkbox
              checked={selectedDays.has(id)}
              onChange={() => onToggle(id)}
            />
          }
          label={name}
          sx={{ mr: [0, 2] }}
        />
      ))}
    </Box>
  );
};
